import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import Resize from 'vuetify/lib/directives/resize';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        !_vm.editHeader
          ? _c(
              "div",
              { staticClass: "d-print-block d-flex justify-space-between" },
              [
                _vm.signatureHeader
                  ? _c("span", { staticClass: "my-auto" }, [
                      _vm._v(_vm._s(_vm.signatureHeader)),
                    ])
                  : _c("span", { staticClass: "d-print-none my-auto" }, [
                      _vm._v("N/A"),
                    ]),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-4 d-print-none",
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function ($event) {
                        _vm.editHeader = true
                      },
                    },
                  },
                  [_c(VIcon, [_vm._v("mdi-pencil")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.editHeader
          ? _c(
              "div",
              [
                _c(VTextField, {
                  attrs: {
                    label: "Signature header",
                    "append-outer-icon": "mdi-check",
                  },
                  on: { "click:append-outer": _vm.saveHeader },
                  model: {
                    value: _vm.signatureHeader,
                    callback: function ($$v) {
                      _vm.signatureHeader = $$v
                    },
                    expression: "signatureHeader",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "d-flex justify-center signature-pad my-2",
          on: { click: _vm.openSignMode },
        },
        [
          _vm.signatureSvg
            ? _c(
                "div",
                {
                  staticStyle: { position: "absolute", "margin-top": "-30px" },
                },
                [
                  _c(VImg, {
                    attrs: {
                      contain: "",
                      "aspect-ratio": 16 / 9,
                      "max-height": "100px",
                      "max-width": "200px",
                      src: _vm.signatureSvg,
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass:
                    "text-center font-weight-thin my-auto mx-10 d-print-none",
                },
                [_vm._v(" Sign Here "), _c(VIcon, [_vm._v("mdi-draw-pen")])],
                1
              ),
        ]
      ),
      _c("div", [
        !_vm.editFooter
          ? _c(
              "div",
              { staticClass: "d-print-block d-flex justify-space-between" },
              [
                _vm.signatureFooter
                  ? _c("div", { staticClass: "d-flex justify-space-between" }, [
                      _c("span", [
                        _vm._v("( " + _vm._s(_vm.signatureFooter) + " )"),
                      ]),
                      _vm.signature
                        ? _c("span", { staticClass: "ml-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDateYear")(
                                  _vm.signature.updatedDate
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("span", { staticClass: "d-print-none" }, [
                      _vm._v("N/A"),
                    ]),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-4 d-print-none",
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function ($event) {
                        _vm.editFooter = true
                      },
                    },
                  },
                  [_c(VIcon, [_vm._v("mdi-pencil")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.editFooter
          ? _c(
              "div",
              [
                _c(VTextField, {
                  attrs: {
                    label: "Signature footer",
                    "append-outer-icon": "mdi-check",
                  },
                  on: { "click:append-outer": _vm.saveFooter },
                  model: {
                    value: _vm.signatureFooter,
                    callback: function ($$v) {
                      _vm.signatureFooter = $$v
                    },
                    expression: "signatureFooter",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        VDialog,
        {
          directives: [
            {
              def: Resize,
              name: "resize",
              rawName: "v-resize",
              value: _vm.onResize,
              expression: "onResize",
            },
          ],
          staticStyle: { zIndex: "1000" },
          attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly, persistent: "" },
          model: {
            value: _vm.signMode,
            callback: function ($$v) {
              _vm.signMode = $$v
            },
            expression: "signMode",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-5" },
            [
              _c(
                VCardSubtitle,
                { staticClass: "d-flex" },
                [
                  _c("div", { staticClass: "my-auto" }, [_vm._v("Sign Below")]),
                  _c(VSpacer),
                  _c(
                    VBtn,
                    { attrs: { icon: "" }, on: { click: _vm.closeDialog } },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                { staticClass: "px-4" },
                [
                  _c(
                    VSheet,
                    { attrs: { elevation: 2 } },
                    [
                      _vm.loaded
                        ? _c("vue-signature", {
                            key: _vm.windowSize.x,
                            ref: "signaturePad",
                            attrs: {
                              h: `${
                                _vm.windowSize.x / 3 < 200
                                  ? 200
                                  : _vm.windowSize.x / 3
                              }px`,
                              w: `${
                                _vm.windowSize.x * 0.8 < 300
                                  ? 300
                                  : _vm.windowSize.x * 0.8
                              }px`,
                              sigOption: _vm.option,
                              defaultUrl: _vm.tempSignatureSvg,
                            },
                            on: { beginStroke: _vm.onBeginStroke },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardActions,
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    VBtn,
                    { staticClass: "ma-2", on: { click: _vm.saveSignature } },
                    [
                      _c(VIcon, { staticClass: "mr-2" }, [
                        _vm._v("mdi-content-save"),
                      ]),
                      _c("span", [_vm._v("Done")]),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    { staticClass: "ma-2", on: { click: _vm.clearSignature } },
                    [
                      _c(VIcon, { staticClass: "mr-2" }, [
                        _vm._v("mdi-eraser"),
                      ]),
                      _c("span", [_vm._v("Clear")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }